<template>
  <ul
    class="server-errors"
    v-if="flatServerErrors && flatServerErrors.length"
    role="alert"
  >
    <li v-for="error in flatServerErrors" :key="error">
      {{ error }}
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'flatServerErrors',
    ]),
  },
};
</script>

<style scoped>
.server-errors {
  background-color: #4eab73;
  color: #fff;
  padding: 1rem;
}
</style>
